export const USER_EMAILVERIFICATION_BEGIN = 'USER_EMAILVERIFICATION_BEGIN'
export const USER_EMAILVERIFICATION_SUCCESS = 'USER_EMAILVERIFICATION_SUCCESS'
export const USER_EMAILVERIFICATION_ERROR = 'USER_EMAILVERIFICATION_ERROR'

export const RESEND_EMAILVERIFICATION_BEGIN =   'RESEND_EMAILVERIFICATION_BEGIN'
export const RESEND_EMAILVERIFICATION_SUCCESS = 'RESEND_EMAILVERIFICATION_SUCCESS'
export const RESEND_EMAILVERIFICATION_ERROR =   'RESEND_EMAILVERIFICATION_ERROR'

export const ONBOARDING_SIGNUP_BEGIN = 'ONBOARDING_SIGNUP_BEGIN'
export const ONBOARDING_SIGNUP_SUCCESS = 'ONBOARDING_SIGNUP_SUCCESS'
export const ONBOARDING_SIGNUP_ERROR = 'ONBOARDING_SIGNUP_ERROR'

export const USER_SIGNUP_BEGIN = 'USER_SIGNUP_BEGIN'
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS'
export const USER_SIGNUP_ERROR = 'USER_SIGNUP_ERROR'

export const VERIFY_EMAIL_BEGIN = 'VERIFY_EMAIL_BEGIN'
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS'
export const VERIFY_EMAIL_ERROR =   'VERIFY_EMAIL_ERROR'

export const IMPORT_USERS_BEGIN =   'IMPORT_USERS_BEGIN'
export const IMPORT_USERS_SUCCESS = 'IMPORT_USERS_SUCCESS'
export const IMPORT_USERS_ERROR =   'IMPORT_USERS_ERROR'
